import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";

import Product from "../../services/product";
import PubSub from "../../services/PubSub";
import Setting from "../../services/setting";
import GenericDropdown from "../controls/GenericDropdown";
import Utils from "../../utils/utils";

const MigrateProductSettings = ({ show, onCancel }) => {
    const [translate] = useTranslation();
    const { id } = useParams();

    const [allProductVersions, setAllProductVersions] = useState([]);
    const [filteredProductVersions, setFilteredProductVersions] = useState([]);
    const [selectedProductVersionId, setSelectedProductVersionId] = useState("");

    const getProductVersions = useCallback(async () => {
        let response = {};
        if (allProductVersions.length === 0) {
            response = await Product.getAllProductVersions(Utils.getDomain());
            if (!response.error) {
                setAllProductVersions(response.data);
            }
        } else {
            response.data = allProductVersions;
        }
        for (const productName of Object.keys(response.data)) {
            for (const { _id } of response.data[productName]) {
                if (id === _id) {
                    setFilteredProductVersions(response.data[productName].filter(({ _id }) => _id !== id));
                }
            }
        }
    }, [id, allProductVersions]);

    useEffect(() => {
        const subscriptionId = PubSub.subscribe("refresh-product-list", () => {
            setAllProductVersions([]);
        });

        return () => PubSub.unsubscribe("refresh-product-list", subscriptionId);
    }, []);

    useEffect(() => {
        if (show) {
            getProductVersions();
        }
    }, [show, getProductVersions]);

    const migrateSettings = useCallback(async () => {
        const versions = [];

        let sourceId, destinationId;

        for (const product in allProductVersions) {
            allProductVersions[product].forEach(version => versions.push(version));
        }

        versions.forEach(version => {
            if (version._id === selectedProductVersionId) {
                sourceId = version.settingsSet
            }
            else if (version._id === id) {
                destinationId = version.settingsSet
            }
        }
        )

        const response = await Setting.migrateSettings(sourceId, destinationId, "productVersion", selectedProductVersionId, id);
        if (!response.error) {
            PubSub.publish("refresh-setting-group-list");
            PubSub.publish("refresh-settings");
            onCancel();
        }
    }, [allProductVersions, selectedProductVersionId, id, onCancel]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">
                {translate("OTM_INITIALISE_PRODUCT_VERSION_FROM")}
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                <GenericDropdown
                    options={filteredProductVersions}
                    heading={translate("OTM_SOURCE_VERSION")}
                    onSelect={setSelectedProductVersionId}
                    valueKey="_id"
                    displayValueKey="productVersion"
                    grow={true}
                />
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button onClick={migrateSettings} className="btn-sm" disabled={selectedProductVersionId === ""}>
                    {translate("OTM_INITIALISE")}
                </Button>
                <Button onClick={onCancel} variant="secondary" className="btn-sm">
                    {translate("OTM_CANCEL")}
                </Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
};

export default MigrateProductSettings;